import { Pipe, PipeTransform } from '@angular/core';

import { TreeNodeZip } from '../models/tree-node.model';

@Pipe({
  name: 'displayNestedElements',
  pure: true
})
export class DisplayNestedElementsPipe implements PipeTransform {
  transform(tree: TreeNodeZip): string {
    const path = tree?.path.join('/');
    return path ? `${path}/${tree.name}` : tree.name;
  }
}
